'use client';

import Image from 'next/image';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import Link from 'next/link';
import { ArrowRight } from 'lucide-react';
import { useTranslations } from 'next-intl';

export function Integration() {
  const t = useTranslations('integration');

  return (
    <section className="py-20 px-4 bg-section-navy">
      <div className="max-w-7xl mx-auto">
        <Card className="bg-gradient-to-r from-white to-of-white border-accent/35 shadow-xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <Badge variant="default" className="mb-4">
                {t('badge')}
              </Badge>
              <h2 className="text-4xl md:text-5xl font-bold mb-4 text-foreground">
                {t('subtitle')}
              </h2>
              <p className="text-2xl text-accent mb-6 font-medium">{t('subtitle2')}</p>
              <p className="text-lg text-foreground mb-8 leading-relaxed">{t('description')}</p>
              <Link href="/comment-ca-marche">
                <Button size="lg" className="group">
                  {t('cta')}
                  <ArrowRight className="ml-2 w-5 h-5 inline-block group-hover:translate-x-1 transition-transform" />
                </Button>
              </Link>
            </div>

            <div className="grid grid-cols-1 gap-4">
              <Card className="bg-accent/15 border-accent/45 p-7 sm:p-8">
                <div className="flex items-start gap-4">
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center">
                    <Image
                      src="/images/safetizen-logo.svg"
                      alt="Safetizen"
                      width={48}
                      height={48}
                      className="max-h-12 max-w-12 h-auto w-auto object-contain"
                      style={{ width: 'auto' }}
                    />
                  </div>
                  <div>
                    <h4 className="text-xl font-semibold text-foreground mb-2">{t('safetizenLabel')}</h4>
                    <p className="text-foreground leading-relaxed">{t('safetizenDescription')}</p>
                  </div>
                </div>
              </Card>

              <Card className="bg-purple/8 border-purple/30 p-7 sm:p-8">
                <div className="flex items-start gap-4">
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center">
                    <Image
                      src="/images/earit-logo.svg"
                      alt="Earit"
                      width={48}
                      height={48}
                      className="max-h-12 max-w-12 h-auto w-auto object-contain"
                      style={{ width: 'auto' }}
                    />
                  </div>
                  <div>
                    <div className="flex flex-wrap items-center gap-2 mb-2">
                      <h4 className="text-lg font-semibold text-foreground">{t('earitLabel')}</h4>
                      <Badge variant="default" className="text-xs px-2 py-0.5">
                        {t('earitOptional')}
                      </Badge>
                    </div>
                    <p className="text-foreground/90 text-sm leading-relaxed">{t('earitDescription')}</p>
                  </div>
                </div>
              </Card>

              <Card className="bg-slate-100 border-slate-300 p-5 sm:p-6 text-center">
                <h4 className="text-foreground font-semibold mb-2">{t('integrationLabel')}</h4>
                <p className="text-foreground text-sm leading-relaxed">{t('integrationDescription')}</p>
              </Card>
            </div>
          </div>
        </Card>
      </div>
    </section>
  );
}
